
import {PermissionsModel} from '../../../common/entity/permissions.model';
import {SummaryModel} from '../../../common/entity/summary.model';

export class OfficeSummaryModel implements SummaryModel{
    id: number;
    name: string;
    active: boolean;
    textColor: string;
    backgroundColor: string;
    permissions: PermissionsModel;
}
